import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useCurrentStore } from "hooks/storeHooks";
import { useIsAuthenticated } from "hooks/userHooks";

import { IRoutes } from "types/IRoutes";

type Props = {
  children: JSX.Element;
};

export const PublicPage = ({ children }: Props) => {
  const isAuthenticated = useIsAuthenticated();
  const { currentStore } = useCurrentStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && currentStore?.storeHash) {
      navigate(`/${currentStore?.storeHash}/${IRoutes.HOME}`);
    }
  }, [currentStore?.storeHash, isAuthenticated, navigate]);

  if (!currentStore) return <></>;

  return children;
};
